import { useAuthContext } from 'auth/metabolism/use-auth-context';

export const useIdentity = () => {
  const { getIdentity } = useAuthContext();
  return getIdentity();
};
